import React from 'react'
import styled from 'styled-components'

const Textarea = styled.textarea`
  resize: vertical;
  width: 100%;
  min-height: 120px;
  border-radius: 3px;
  padding: 10px;
  border: 1px solid #99a5ab;
`

export default React.forwardRef(({ onChange, ...rest }, ref) => (
  <Textarea
    ref={ref}
    onChange={onChange && (e => onChange(e.target.value))}
    {...rest}
  />
))
